import { TimeLineBody } from '@components/ui/TimeLine/TimeLineBody';
import { TimelineEyebrow } from '@components/ui/TimeLine/TimelineEyebrow';
import { TimeLineFooter } from '@components/ui/TimeLine/TimeLineFooter';
import { TimeLineHeader } from '@components/ui/TimeLine/TimeLineHeader';
import { TimeLineItem } from '@components/ui/TimeLine/TimeLineItem';
import { TimeLineItemCard } from '@components/ui/TimeLine/TimeLineItemCard';
import { TimeLineItemIcon } from '@components/ui/TimeLine/TimeLineItemIcon';
import { TimeLineSignature } from '@components/ui/TimeLine/TimeLineSignature';
import { TimeLineTitle } from '@components/ui/TimeLine/TimeLineTitle';
import { DocumentArrowUpIcon } from '@heroicons/react/24/outline';
import { format } from 'date-fns';

import { type DocumentTimeLineItemProps } from './types';

const DocumentTimeLineItem = ({
  action,
  date,
  reason,
  status,
}: DocumentTimeLineItemProps) => {
  return (
    <TimeLineItem>
      <TimeLineItemIcon>
        <DocumentArrowUpIcon />
      </TimeLineItemIcon>
      <TimeLineItemCard>
        <TimeLineHeader>
          <TimelineEyebrow>{format(date, 'dd/MM/yyy HH:mm')}</TimelineEyebrow>
          <TimeLineTitle>{action} DICOM</TimeLineTitle>
        </TimeLineHeader>
        <TimeLineBody>
          <p>Estado: {status}</p>
          {reason}
        </TimeLineBody>
        <TimeLineFooter>
          <TimeLineSignature>Tarea automática</TimeLineSignature>
        </TimeLineFooter>
      </TimeLineItemCard>
    </TimeLineItem>
  );
};

export { DocumentTimeLineItem };
